export const types = {
  REF_REQUEST: 'SIGNUPS/REF_REQUEST',
  REF_SUCCESS: 'SIGNUPS/REF_SUCCESS',
  REF_FAILURE: 'SIGNUPS/REF_FAILURE',
  PROMO_REQUEST: 'SIGNUPS/PROMO_REQUEST',
  PROMO_SUCCESS: 'SIGNUPS/PROMO_SUCCESS',
  PROMO_FAILURE: 'SIGNUPS/PROMO_FAILURE',
  SKILLS_REQUEST: 'SIGNUPS/SKILLS_REQUEST',
  SKILLS_SUCCESS: 'SIGNUPS/SKILLS_SUCCESS',
  SKILLS_FAILURE: 'SIGNUPS/SKILLS_FAILURE',
  DEVELOPER_SIGNUP_REQUEST: 'SIGNUPS/DEVELOPER_SIGNUP_REQUEST',
  DEVELOPER_SIGNUP_SUCCESS: 'SIGNUPS/DEVELOPER_SIGNUP_SUCCESS',
  DEVELOPER_SIGNUP_FAILURE: 'SIGNUPS/DEVELOPER_SIGNUP_FAILURE',
  REVIEWER_SIGNUP_REQUEST: 'SIGNUPS/REVIEWER_SIGNUP_REQUEST',
  REVIEWER_SIGNUP_SUCCESS: 'SIGNUPS/REVIEWER_SIGNUP_SUCCESS',
  REVIEWER_SIGNUP_FAILURE: 'SIGNUPS/REVIEWER_SIGNUP_FAILURE',
  UPDATE_REVIEWER_PROFILE_REQUEST: 'SIGNUPS/CREATE_REVIEWER_PROFILE_REQUEST',
  UPDATE_REVIEWER_PROFILE_SUCCESS: 'SIGNUPS/CREATE_REVIEWER_PROFILE_SUCCESS',
  UPDATE_REVIEWER_PROFILE_FAILURE: 'SIGNUPS/CREATE_REVIEWER_PROFILE_FAILURE',
  ADD_REVIEWER_INFO_REQUEST: 'SIGNUPS/ADD_REVIEWER_INFO_REQUEST',
  ADD_REVIEWER_INFO_SUCCESS: 'SIGNUPS/ADD_REVIEWER_INFO_SUCCESS',
  ADD_REVIEWER_INFO_FAILURE: 'SIGNUPS/ADD_REVIEWER_INFO_FAILURE',
  STORE_SKILLS_REQUEST: 'SIGNUPS/STORE_SKILLS_REQUEST',
  STORE_SKILLS_SUCCESS: 'SIGNUPS/STORE_SKILLS_SUCCESS',
  STORE_SKILLS_FAILURE: 'SIGNUPS/STORE_SKILLS_FAILURE',
  COMPLETE_REVIEWER_SIGNUP_REQUEST: 'SIGNUPS/COMPLETE_REVIEWER_SIGNUP_REQUEST',
  COMPLETE_REVIEWER_SIGNUP_SUCCESS: 'SIGNUPS/COMPLETE_REVIEWER_SIGNUP_SUCCESS',
  COMPLETE_REVIEWER_SIGNUP_FAILURE: 'SIGNUPS/COMPLETE_REVIEWER_SIGNUP_FAILURE',
  CHECK_EMAIL_REQUEST: 'SIGNUPS/CHECK_EMAIL_REQUEST',
  CHECK_EMAIL_SUCCESS: 'SIGNUPS/CHECK_EMAIL_SUCCESS',
  CHECK_EMAIL_FAILURE: 'SIGNUPS/CHECK_EMAIL_FAILURE',
  SLACK_INVITE_REQUEST: 'ACCOUNT/SLACK_INVITE_REQUEST',
  SLACK_INVITE_FAILURE: 'ACCOUNT/SLACK_INVITE_FAILURE',
  SLACK_INVITE_SUCCESS: 'ACCOUNT/SLACK_INVITE_SUCCESS',
  REVIEWER_TERMS_REQUEST: 'SIGNUPS/REVIEWER_TERMS_REQUEST',
  REVIEWER_TERMS_FAILURE: 'SIGNUPS/REVIEWER_TERMS_FAILURE',
  REVIEWER_TERMS_SUCCESS: 'SIGNUPS/REVIEWER_TERMS_SUCCESS',
};

export const initialState = {
  error: null,
  isLoading: false,
  isUpdating: false,
  ref: null,
  promo: null,
  skills: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REF_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.REF_SUCCESS:
      return { ...state, isLoading: false, ref: action.ref };
    case types.REF_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.PROMO_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.PROMO_SUCCESS:
      return { ...state, isLoading: false, promo: action.promo };
    case types.PROMO_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.SKILLS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.SKILLS_SUCCESS: {
      const { skills } = action;
      return { ...state, isLoading: false, promo: action.promo, skills };
    }
    case types.SKILLS_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.DEVELOPER_SIGNUP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DEVELOPER_SIGNUP_SUCCESS:
      return { ...state, isLoading: false };
    case types.DEVELOPER_SIGNUP_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.REVIEWER_SIGNUP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.REVIEWER_SIGNUP_SUCCESS:
      return { ...state, isLoading: false };
    case types.REVIEWER_SIGNUP_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.STORE_SKILLS_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.STORE_SKILLS_SUCCESS:
      return { ...state, isUpdating: false };
    case types.STORE_SKILLS_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.COMPLETE_REVIEWER_SIGNUP_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.COMPLETE_REVIEWER_SIGNUP_SUCCESS:
      return { ...state, isUpdating: false };
    case types.COMPLETE_REVIEWER_SIGNUP_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.UPDATE_REVIEWER_PROFILE_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.UPDATE_REVIEWER_PROFILE_SUCCESS:
      return { ...state, isUpdating: false };
    case types.UPDATE_REVIEWER_PROFILE_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.ADD_REVIEWER_INFO_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.ADD_REVIEWER_INFO_SUCCESS:
      return { ...state, isUpdating: false };
    case types.ADD_REVIEWER_INFO_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.SLACK_INVITE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.SLACK_INVITE_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.SLACK_INVITE_SUCCESS:
      return { ...state, isLoading: false };
    case types.REVIEWER_TERMS_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.REVIEWER_TERMS_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case types.REVIEWER_TERMS_SUCCESS:
      return { ...state, isUpdating: false };
    default:
      return state;
  }
};

export const actions = {
  fetchRef: (ref) => ({ type: types.REF_REQUEST, ref }),
  fetchPromo: (signUpCode) => ({
    type: types.PROMO_REQUEST,
    signUpCode,
  }),
  fetchSkills: () => ({ type: types.SKILLS_REQUEST }),
  developerSignUp: (
    name,
    email,
    password,
    company,
    companyUrl,
    termsAccepted,
    plan,
    signUpCode,
    ref,
    benchmarksSignup
  ) => ({
    type: types.DEVELOPER_SIGNUP_REQUEST,
    name,
    email,
    password,
    company,
    companyUrl,
    termsAccepted,
    plan,
    signUpCode,
    ref,
    benchmarksSignup,
  }),
  reviewerSignUp: (name, email, password, phone) => ({
    type: types.REVIEWER_SIGNUP_REQUEST,
    name,
    email,
    password,
    phone,
  }),
  updateReviewerProfile: (github, linkedin, resume, additionalLinks) => ({
    type: types.UPDATE_REVIEWER_PROFILE_REQUEST,
    github,
    linkedin,
    resume,
    additionalLinks,
  }),
  addReviewerInfo: ({
    hourlyRate,
    yearsDevExperience,
    yearsCodeReview,
    reviewDescription,
  }) => ({
    type: types.ADD_REVIEWER_INFO_REQUEST,
    hourlyRate,
    yearsDevExperience,
    yearsCodeReview,
    reviewDescription,
  }),
  storeReviewerSkills: (skills, complete = false) => ({
    type: types.STORE_SKILLS_REQUEST,
    skills,
    complete,
  }),
  completeReviewerSignUp: () => ({
    type: types.COMPLETE_REVIEWER_SIGNUP_REQUEST,
  }),
  checkUserEmail: (email) => ({
    type: types.CHECK_EMAIL_REQUEST,
    email,
  }),
  getReviewerSlackUrl: (callback) => ({
    type: types.SLACK_INVITE_REQUEST,
    callback,
  }),
  acceptReviewerTerms: () => ({
    type: types.REVIEWER_TERMS_REQUEST,
  }),
};
